import { render, staticRenderFns } from "./MetricWidget.vue?vue&type=template&id=27cc7746"
import script from "./MetricWidget.vue?vue&type=script&lang=js"
export * from "./MetricWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports